import { type UseQueryResult, useQuery } from 'react-query';
import {
  SystemAlertConfigurationService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_SystemAlertConfigurationDto,
} from '@wealthlane/api-services/wealthlane-identity-service';
import { type TableParamsType } from '../../types/common';

const useGetSystemAlertConfigurationList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo?: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_SystemAlertConfigurationDto | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount } = tableInfo ?? {};
  const systemAlertConfigurationList = useQuery(
    ['getSystemAlertConfigurationList', filter, sorting, skipCount, maxResultCount],
    async () => {
      return await handleRequest(
        SystemAlertConfigurationService.getApiIdentityApiAppSystemAlertConfigurationPaginatedList(
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return systemAlertConfigurationList;
};

export default useGetSystemAlertConfigurationList;
